/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Badge } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { navigateToRetailerSurvey } from "app/navigation";
import { resetSurveyNotification } from "reducers/survey/survey";
/* Project Import will be here */

const SurveyNotificationModal = (props) => {
    const { translate, surveyNotification } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        surveyNotification: state.survey.surveyNotification
    }));

    const dispatch = useDispatch();

    const handleCancel = () => {
        dispatch(resetSurveyNotification());
    }

    const handleOk = () => {
        dispatch(resetSurveyNotification());
        dispatch(navigateToRetailerSurvey());
    }

    const renderComponent = () => {
        return (
            <Modal
                visible={surveyNotification.data.length > 0 ? true : false}
                centered
                maskClosable={false}
                title={
                    <React.Fragment>
                        <i className="fa fa-exclamation-triangle fa-lg color-red" aria-hidden="true"></i>
                        <span className="ml-2">{translate("survey.surveyNotification.title")}</span>
                    </React.Fragment>
                }
                closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                onCancel={handleCancel}
                footer={[
                    <Button
                        key="ok"
                        onClick={handleOk}
                        type="primary"
                        size="large"
                        className="button-height">
                        {translate("common.buttons.goToSurvey")}
                    </Button>
                ]}
                className="survey-notification-modal"
            >
                <React.Fragment>
                    <h6 className="text-bold mb-2">{translate("survey.surveyNotification.description")}</h6>
                    {surveyNotification.data.map((item, index) => (
                        <div key={item.SurveyId} className="mb-1">
                            <Badge className="survey-notification-name" color="#1F285D" text={item.SurveyName} />
                        </div>
                    ))}
                </React.Fragment>
            </Modal>
        )
    };

    return (renderComponent());
}

export default SurveyNotificationModal;